import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
// import 'react-data-table-component-extensions/dist/utilities';
import {CSVLink} from 'react-csv';
import { ExportToExcelLive } from '../Excelfile';
import { ExportToExcelPartyLive } from '../Excelfile';
import Navbar from '../Navbar';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Loaders from './Spinners/Loaders';




const Tcsreport = () => {
    
    const navigate = useNavigate();

    
    const [userData, setUserData] = useState({});    
    const [filtereddata, setFiltereddata] = useState([]);
    const [filtereddncndata, setFiltereddncndata] = useState([]);
    const [tcsdbdata, setTcsdbdata] = useState({});
    const [values, setValues] = useState([]);
    const [usermapData, setUsermapData] = useState({});
    const [userdivmapData, setUserdivmapData] = useState({});
    const [btnsitestate, setBtnsitestate] = useState('');
    const [btnrefstate, setBtnrefstate] = useState('none');
    const [btnstate, setBtnstate] = useState('none');
    const [hqbtnstate, setHqbtnstate] = useState('none');
    const [partybtnstate, setPartybtnstate] = useState('none');
    const [btnreport, setBtnreport] = useState('none');
    const [btndncnreport, setBtndncnreport] = useState('none');
    const senempmapdata = userData.empCode;
    const sendivempmapdata = userData.empCode;
    const [datefromValue, setDatefromValue] = useState(null);
    const [datetoValue, setDatetoValue] = useState(null);
    const [ffdata, setFfdata] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [partywisedata, setPartywisedata] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);
    // const [isError, setIsError] = useState(false);
    
    
    
function formatDate(date) {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) 
    month = '0' + month;
  if (day.length < 2) 
    day = '0' + day;

  return [year, month, day].join('');
}

    
    
    // const tcsfromDate = tcsddata.tcsdateformonth;
    // const tcstoDate = tcsddata.tcsdatetillmonth;

    const tcsfromDate = datefromValue;
    const tcstoDate = datetoValue;
    const sapfromDate = formatDate(datefromValue);
    const saptoDate = formatDate(datetoValue);
    

    
    let finalsitemapdata = '';
    
    for(let i=0; i < usermapData.length; i++)
    {
        finalsitemapdata = finalsitemapdata + usermapData[i].siteCode + ",";
    }

    let finalplantmapdata = '';
    
    for(let i=0; i < usermapData.length; i++)
    {
        finalplantmapdata = finalplantmapdata + usermapData[i].plant + ",";
    }

    let finaldivmapdata = '';
    
    
    for(let i=0; i < userdivmapData.length; i++)
    {
        finaldivmapdata = finaldivmapdata + userdivmapData[i].divisionCode + ",";
    }
   
      let finlsapdivmapdata = [];  
    for(let i=0; i < userdivmapData.length; i++)
    {
        finlsapdivmapdata[i] = userdivmapData[i].divisionone;
    }
    const uniquefinlsapdivmapdata = [...new Set(finlsapdivmapdata)];
    // console.log(uniquefinlsapdivmapdata);
    

    const empdivemapdata = async () => {
        
        try {
            if(!sendivempmapdata || !datefromValue || !datetoValue)
            {
                toast.error("Please Select the Date Filter or Connect to QRS-Administration.", { position: "top-center" });
            }
            else if(datefromValue > datetoValue)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 92)
            {
              toast.error("Please select the below 3 Months data.", { position: "top-center" });
            }
            else
            {
              
            const res = await fetch('/tcsdb/divemapdata/'+sendivempmapdata, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            const empmapdata = await res.json();
            if(res.status === 404)
            {
                toast.error("You have Zero Data Available.", { position: "top-center" });
            }
            else
            {
            setUserdivmapData(empmapdata);
            setBtnsitestate('none');            
            setBtnrefstate('');
            // console.log(empmapdata);
            // console.log(finalsitemapdata);
            }
        }
        } catch (err) {
            console.log(err);
            
        }

    }

    const empsitemapdata = async () => {
        
        try {
            if(!senempmapdata)
            {
                toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
            }
            else
            {
            const res = await fetch('/tcsdb/sitemapdata/'+senempmapdata, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            const empmapdata = await res.json();
            if(res.status === 404)
            {
                toast.error("You have Zero Data Available.", { position: "top-center" });
            }
            else
            {
            setUsermapData(empmapdata);
            
            setBtnrefstate('none');
            setBtnreport('');
            // console.log(empmapdata);
            // console.log(finalsitemapdata);
            }
        }
        } catch (err) {
            console.log(err);
            
        }

    }


    const empdataHomePage = async () => {
        try {
            const res = await fetch('/user/empmasterdata');
            const empdata = await res.json();        
            setUserData(empdata); 
            // console.log(empdata);
        } catch (err) {
            console.log(err);
            
        }
    
    }    

    // const currentdatadate = async () => {
    //     try {
    //       const Tcsdbres = await fetch('/homedb/dashboardata');
    //       const tcsdbresdata = await Tcsdbres.json();
    //     //   console.log(tcsdbresdata);
    //       SetTcsddata(tcsdbresdata);
        
          
    //     } catch (error) {
    //       console.log(error);
    //     }
    //   }


      

      const handlefromDateUpdate = async(e) => {        
        const datefValue = e.target.value;        
        // console.log("from:", datefValue);
        setDatefromValue(datefValue);       
        // console.log("from:", datefValue);        
      }

      const handletoDateUpdate = async(e) => {        
        const datetValue = e.target.value;        
        // console.log("to:", datetValue);        
        setDatetoValue(datetValue);       
        // console.log("to:", datetValue);
      }

      const hqcodelist = async () => {
        try {
            let hqhirdata = userData.hqCode;
            // console.log(hqhirdata);
            const hqres = await fetch('/tcsdb/hirhqmapdata/'+hqhirdata, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            
            const hqresdata = await hqres.json();
            if(hqresdata.status === 404)
            {
                toast.error("You don't have access of HQ.", { position: "top-center" });
            }
            else
            {
            // console.log(hqresdata);
            setValues(hqresdata);
            }
        
          
        } catch (error) {
          console.log(error);
        }
      }


      const partywiselist = async () => {
        try {
            // let hqhirdata = userData.hqCode;
            // console.log(hqhirdata);
            // console.log("hi");
            const partywiseres = await fetch('/tcsdb/partywisereport', {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            
            const partywiseresdata = await partywiseres.json();
            if(partywiseres.status === 404)
            {
                toast.error("There is no Data for Display.", { position: "top-center" });
            }
            else
            {
            // console.log(partywiseresdata);
            setPartywisedata(partywiseresdata);
            }
        
          
        } catch (error) {
          console.log(error);
        }
      }


      const handlehqwisedata = () => {
        
        setHqbtnstate('none');
        if(filtereddata.length <=0)
        {
          toast.error("There are no record to display.", { position: "top-center" });
        }
        else{
        // let myArray = [];
        for(let i =0; i<values.length; i++ )
        {
          let temp = values[i].hqCode;
          // let tempname = values[i].hqName;
          // console.log(values);
          // console.log(temp);
          let sval = 0;
          let svaldncn= 0;
          for(let j=0; j<filtereddata.length; j++)
          {
            if(filtereddata[j].HQ_CODE === temp)  // For SAP            
            // if(filtereddata[j].HQ_Code === temp) // For TCS
            // sval += filtereddata[j].Amount_after_Discount; // For TCS
            sval += filtereddata[j].TAXABLE_AMOUNT; // for SAP            
          }

          for(let j=0; j<filtereddncndata.length; j++)
          {            
            if(filtereddncndata[j].HQ_CODE === temp)  // For SAP
            svaldncn += filtereddncndata[j].TAXABLE_AMOUNT; // for SAP
          }
          // myArray[i]=("HQ Code:-" + temp + "HQ Name:" +tempname + "Sale Value:" + Math.round(sval,2));
          // ("HQ Code:-" + temp + "HQ Name:" +tempname + "Sale Value:" + Math.round(sval,2));
          // console.log("HQ Code:-" + temp + "HQ Name:" +tempname + "Sale Value:" + Math.round(sval,2));
          values[i].SalesValue = sval;
          values[i].DebitCreditNote = svaldncn;
          values[i].DiffValue = values[i].SalesValue + values[i].DebitCreditNote - values[i].CurrentIQMValue;
        }
        // partywisereport();

        setHqbtnstate('');
      }
      }



      // let PTN = 0;
      // let NUC = 0;
      // let MOL = 0;
      // let RES = 0;
      // let ADF = 0;
      // let ATM = 0;
      // let BLP =0;
      // let LUX = 0;
      // let CPCdiv = 0;
      // let CSDdiv = 0;      

      // for(let i = 0; i < filtereddata.length; i++)
      // {
      //   if(filtereddata[i].Item_Division === 'OPL-PROTON - OPL-PROTON' || filtereddata[i].Item_Division === 'OPL-CARDIAZONE - OPL-CARDIAZONE')
      //   {PTN += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-NUCLEUS - OPL-NUCLEUS' || filtereddata[i].Item_Division === 'OPL-CEFILABZONE - OPL-CEFILABZONE' )
      //   {NUC += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-MOLECULE - OPL-MOLECULE')
      //   {MOL += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-ADLIFE - OPL-ADLIFE')
      //   {ADF += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-BLIP - OPL-BLIP' )
      //   {BLP += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-ATOM - OPL-ATOM' )
      //   {ATM += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-CPC - OPL-CPC' )
      //   {CPCdiv += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-CSD - OPL-CSD' )
      //   {CSDdiv += filtereddata[i].Amount_after_Discount;}
      //   else if(filtereddata[i].Item_Division === 'OPL-MTO - OPL-MTO' || filtereddata[i].Item_Division === 'OPL-PROFESSIONAL - OPL-PROFESSIONAL' )
      //   {LUX += filtereddata[i].Amount_after_Discount;}
      //   else{
      //     RES += filtereddata[i].Amount_after_Discount;
      //   }
      // } 


      // let Proton = Math.round(PTN/100000*100)/100;
      // let Nucleus = Math.round(NUC/100000*100)/100;
      // let Molecule = Math.round(MOL/100000*100)/100;
      // let Adlife = Math.round(ADF/100000*100)/100;
      // let Blip = Math.round(BLP/100000*100)/100;
      // let ATOM = Math.round(ATM/100000*100)/100;
      // let OPR =Math.round(LUX/100000*100)/100;
      // let CPC =Math.round(CPCdiv/100000*100)/100;
      // let CSD =Math.round(CSDdiv/100000*100)/100;
      // let rest = Math.round(RES/100000*100)/100;
      // let TotalValue = Math.round((Proton+Nucleus+Molecule+Adlife+Blip+ATOM+OPR+CPC+CSD+rest)*100)/100;

    const divwisereport = async () => {        
        try {          
            let frontsitedata = finalsitemapdata;
            let frontitemDivision = finaldivmapdata;            
            if(!senempmapdata || !frontsitedata || !frontitemDivision || !tcsfromDate || !tcstoDate)
            {
                toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
            }
            else if(tcsfromDate > tcstoDate)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 92)
            {
              toast.error("Please select the below 3 Months data.", { position: "top-center" });
            }
            else
            {
            setBtnreport('true');
            setBtnstate('none');
            setIsLoading(true);
            // const res = await fetch('/tcsdb/divwisereport/'+ frontsitedata +`/`+ frontitemDivision +`/`+ tcsfromDate +`/`+ tcstoDate, {
            //     method: "GET",
            //     headers:{
            //         Accept: "application/json",
            //         "Content-Type": "application/json",
            //     },
            //     credentials: "include"
            // })
            // const res = await fetch('https://g21m12.tcsion.com:443/iONBizServices/iONWebService?isContentBody=1&servicekey=RabBGm26KdJK5UcYcWVAwA%3D%3D&u=NE87IXLBBQFcHPqFGgd0Eu5ItASCLwEHKljSu6aOrIDVsTojzChB5EHMO2W%2B9%2BmG&site=OP17_CFA_LKN1&fromDate=01-10-2023&toDate=09-10-2023&itemDivision=OPL-PROTON', {
            //     method: "GET",               
            //     headers: {
            //     'Access-Control-Allow-Origin':'*',
            //     Accept: "application/json",
            //     "Content-Type": "application/json",
            //     },
            //     credentials: "include"
            // });
            // let url = "https://g21m12.tcsion.com:443/iONBizServices/iONWebService?isContentBody=1&servicekey=RabBGm26KdJK5UcYcWVAwA%3D%3D&u=NE87IXLBBQFcHPqFGgd0Eu5ItASCLwEHKljSu6aOrIDVsTojzChB5EHMO2W%2B9%2BmG&site=OP17_CFA_LKN1&fromDate=01-10-2023&toDate=04-10-2023&itemDivision=OPL-PROTON";
            //     fetch(url).then((res) => {
            //       res.json().then((res1) =>{
            //         console.log(res1);
            //       })
            //     })
            const data = { frontsitedatas:"", frontitemDivisions:"", tcsfromDates:"", tcstoDates:"", partyCodes:"" };

            const res = await fetch('/tcsdb/divwisereports',{
              method: "POST",
              headers:{
                  // "Accept": "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                frontsitedatas:finalsitemapdata, frontitemDivisions: finaldivmapdata, tcsfromDates:tcsfromDate, tcstoDates: tcstoDate, partyCodes:""
              })})
            
            const salesdata = await res.json();
            const fsalesdata = await salesdata.filter((fdata) => (fdata.HQ_Code !== ""))
            // console.log(fsalesdata);
            // setTcsdbdata(fsalesdata);
            setIsLoading(false);
            setFiltereddata(fsalesdata);
            setBtnstate('');
            setBtnreport('');
            
        } 
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            setBtnreport('');
            // setIsError(true)
            
        }
    }


      let PTN = 0;
      let NUC = 0;
      let MOL = 0;
      let RES = 0;
      let ADF = 0;
      let ATM = 0;
      let BLP =0;
      let LUX = 0;
      let CPCdiv = 0;
      let CSDdiv = 0;      

      for(let i = 0; i < filtereddata.length; i++)
      {
        if(filtereddata[i].DIVISION_DESCPRIPTION === 'Proton')
        {PTN += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'Nucleus' )
        {NUC += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'Molecule')
        {MOL += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'Adlife')
        {ADF += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'Blip' )
        {BLP += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'Atom' )
        {ATM += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'CPC' )
        {CPCdiv += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'CSD' )
        {CSDdiv += filtereddata[i].TAXABLE_AMOUNT;}
        else if(filtereddata[i].DIVISION_DESCPRIPTION === 'OPR' )
        {LUX += filtereddata[i].TAXABLE_AMOUNT;}
        else{
          RES += filtereddata[i].TAXABLE_AMOUNT;
        }
      } 


      let Proton = Math.round(PTN/100000*100)/100;
      let Nucleus = Math.round(NUC/100000*100)/100;
      let Molecule = Math.round(MOL/100000*100)/100;
      let Adlife = Math.round(ADF/100000*100)/100;
      let Blip = Math.round(BLP/100000*100)/100;
      let ATOM = Math.round(ATM/100000*100)/100;
      let OPR =Math.round(LUX/100000*100)/100;
      let CPC =Math.round(CPCdiv/100000*100)/100;
      let CSD =Math.round(CSDdiv/100000*100)/100;
      let rest = Math.round(RES/100000*100)/100;
      let TotalValue = Math.round((Proton+Nucleus+Molecule+Adlife+Blip+ATOM+OPR+CPC+CSD+rest)*100)/100;

// Below quarry for DebitCreditnote
      let PTNDN = 0;
      let NUCDN = 0;
      let MOLDN = 0;
      let RESDN = 0;
      let ADFDN = 0;
      let ATMDN = 0;
      let BLPDN =0;
      let LUXDN = 0;
      let CPCdivDN = 0;
      let CSDdivDN = 0;      

      for(let i = 0; i < filtereddncndata.length; i++)
      {
        if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'Proton')
        {PTNDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'Nucleus' )
        {NUCDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'Molecule')
        {MOLDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'Adlife')
        {ADFDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'Blip' )
        {BLPDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'Atom' )
        {ATMDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'CPC' )
        {CPCdivDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'CSD' )
        {CSDdivDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else if(filtereddncndata[i].DIVISION_DESCPRIPTION === 'OPR' )
        {LUXDN += filtereddncndata[i].TAXABLE_AMOUNT;}
        else{
          RESDN += filtereddncndata[i].TAXABLE_AMOUNT;
        }
      } 


      let Protondncn = Math.round(PTNDN/100000*100)/100;
      let Nucleusdncn = Math.round(NUCDN/100000*100)/100;
      let Moleculedncn = Math.round(MOLDN/100000*100)/100;
      let Adlifedncn = Math.round(ADFDN/100000*100)/100;
      let Blipdncn = Math.round(BLPDN/100000*100)/100;
      let ATOMdncn = Math.round(ATMDN/100000*100)/100;
      let OPRdncn =Math.round(LUXDN/100000*100)/100;
      let CPCdncn =Math.round(CPCdivDN/100000*100)/100;
      let CSDdncn =Math.round(CSDdivDN/100000*100)/100;
      let restdncn = Math.round(RESDN/100000*100)/100;
      let TotalValuedncn = Math.round((Protondncn+Nucleusdncn+Moleculedncn+Adlifedncn+Blipdncn+ATOMdncn+OPRdncn+CPCdncn+CSDdncn+restdncn)*100)/100;

    const sapdivwisereport = async () => {        
        try {          
            let frontsitedata = finalsitemapdata;
            let frontitemDivision = finaldivmapdata;            
            if(!senempmapdata || !frontsitedata || !frontitemDivision || !tcsfromDate || !tcstoDate)
            {
                toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
            }
            else if(tcsfromDate > tcstoDate)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 32)
            {
              toast.error("Please select the below 1 Months data.", { position: "top-center" });
            }
            else
            {
            setBtnreport('true');
            setBtnstate('none');
            setIsLoading(true);
            // const res = await fetch('/tcsdb/divwisereport/'+ frontsitedata +`/`+ frontitemDivision +`/`+ tcsfromDate +`/`+ tcstoDate, {
            //     method: "GET",
            //     headers:{
            //         Accept: "application/json",
            //         "Content-Type": "application/json",
            //     },
            //     credentials: "include"
            // })
            // const res = await fetch('https://g21m12.tcsion.com:443/iONBizServices/iONWebService?isContentBody=1&servicekey=RabBGm26KdJK5UcYcWVAwA%3D%3D&u=NE87IXLBBQFcHPqFGgd0Eu5ItASCLwEHKljSu6aOrIDVsTojzChB5EHMO2W%2B9%2BmG&site=OP17_CFA_LKN1&fromDate=01-10-2023&toDate=09-10-2023&itemDivision=OPL-PROTON', {
            //     method: "GET",               
            //     headers: {
            //     'Access-Control-Allow-Origin':'*',
            //     Accept: "application/json",
            //     "Content-Type": "application/json",
            //     },
            //     credentials: "include"
            // });
            // let url = "https://g21m12.tcsion.com:443/iONBizServices/iONWebService?isContentBody=1&servicekey=RabBGm26KdJK5UcYcWVAwA%3D%3D&u=NE87IXLBBQFcHPqFGgd0Eu5ItASCLwEHKljSu6aOrIDVsTojzChB5EHMO2W%2B9%2BmG&site=OP17_CFA_LKN1&fromDate=01-10-2023&toDate=04-10-2023&itemDivision=OPL-PROTON";
            //     fetch(url).then((res) => {
            //       res.json().then((res1) =>{
            //         console.log(res1);
            //       })
            //     })
            const data = { frontsitedatas:"", frontitemDivisions:"", tcsfromDates:"", tcstoDates:"", partyCodes:"" };

            const res = await fetch('/tcsdb/sapdivwisereports',{
              method: "POST",
              headers:{
                  // "Accept": "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                frontsitedatas:finalplantmapdata, frontitemDivisions: finaldivmapdata, tcsfromDates:sapfromDate, tcstoDates: saptoDate, partyCodes:""
              })})
            
            const salesdata = await res.json();
            // const searchterms = ['Proton', 'Nucleus'];
            // const divsalesdatas = await salesdata.includes(50);
            const divsalesdata = await salesdata.filter((fdivdata) => uniquefinlsapdivmapdata.some(term => fdivdata.DIVISION_DESCPRIPTION.toLowerCase().includes(term.toLowerCase())));
            // const fsalesdata = await divsalesdata.filter((fdata) => (fdata.CUSTOMER_CATOGERY == "09"))
            // console.log(fsalesdata);
            // setTcsdbdata(fsalesdata);
            setIsLoading(false);
            setFiltereddata(divsalesdata);
            setBtnstate('');
            setBtnreport('');
            
        } 
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            setBtnreport('');
            // setIsError(true)
            
        }
    }

    const sapdivwisedncnreport = async () => {        
        try {          
            let frontsitedata = finalsitemapdata;
            let frontitemDivision = finaldivmapdata;            
            if(!senempmapdata || !frontsitedata || !frontitemDivision || !tcsfromDate || !tcstoDate)
            {
                toast.error("Please Connect to QRS-Administration.", { position: "top-center" });
            }
            else if(tcsfromDate > tcstoDate)
            {
              toast.error("Please select the Correct Date Range.", { position: "top-center" });
            }
            else if((Date.parse(datetoValue)-Date.parse(datefromValue))/86400000 > 32)
            {
              toast.error("Please select the below 1 Months data.", { position: "top-center" });
            }
            else
            {
            setBtnreport('true');
            setBtnstate('none');
            setIsLoading(true);
            
            const data = { frontsitedatas:"", frontitemDivisions:"", tcsfromDates:"", tcstoDates:"", partyCodes:"" };

            const res = await fetch('/tcsdb/sapdivwisedncnreports',{
              method: "POST",
              headers:{
                  // "Accept": "application/json",
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                frontsitedatas:finalplantmapdata, frontitemDivisions: finaldivmapdata, tcsfromDates:sapfromDate, tcstoDates: saptoDate, partyCodes:""
              })})
            
            const dncndata = await res.json();            
            const divdncndata = await dncndata.filter((fdivdata) => uniquefinlsapdivmapdata.some(term => fdivdata.DIVISION_DESCPRIPTION.toLowerCase().includes(term.toLowerCase())));            
            setIsLoading(false);
            setFiltereddncndata(divdncndata);
            console.log(divdncndata);
            setBtnstate('');
            setBtnreport('');
            setBtndncnreport('');
            
        } 
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            setBtnreport('');
            setBtndncnreport('');
            // setIsError(true)
            
        }
    }
   
    

    const pagauth = async() => {
        const pageids = "tcsuserlivereportPage";
        const res = await fetch('/user/pageaccessdatas/'+ pageids, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          credentials: "include"
        })
      
        // const expdata = await res.json();  
        if(res.status === 404)
        {
          navigate('/Home');
          toast.error("You don't have access this page.", { position: "top-center" });
        }
      }

      const refreshdata = async() => {

        const res = await fetch('/tcsdb/refreshpardata', {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          credentials: "include"
        })

      }


      // const handleChange = (state) => {
      //   setSelectedData(state.selectedRows);
      //   console.log(selectedData);
      // };

      // const partyCodelist = () => {
      //   let myArray = [];
      //   // let myArray =  new ArrayList()
        
      //   for (let data of filtereddata)
      //   {
      //     myArray.push(data.Party_Code);
      //     myArray.push(data.Party_Name);
      //     // myArray.push(data.id);
      //     // myArray.push(data.id);
          
      //   }
      //   console.log(myArray);
      // }


      const partywisereport = () => {

        // let a = filtereddata.filter((item) => (item.Party_Code));
        // let soresult = filtereddata.Party_Code;
        // let unique = a.filter((item, i, ar)=> ar.indexOf(item) === i);
        // console.log(soresult);
        try {        
        setPartybtnstate('none');
        if(filtereddata.length <=0)
        {          
          toast.error("There is not data for Display.", { position: "top-center" });
        }
        else
        {
        let hashmap = new Map();
        
        let arr = [];
        // let arrdata = new Array[500][2];
        let j=0;
        let partySalesValue =0;
        // setPartydata("");
        for(let i=0; i<filtereddata.length; i++)
        {          
          if(hashmap.has(filtereddata[i].Party_Code) === false)
          {          
          hashmap.set(filtereddata[i].Party_Code,0)
          // arrdata[j][0] = filtereddata[i].Party_Code;
          // hashmap.set(filtereddata[i].Amount_after_Discount)
          // partydata.Party_Codes = filtereddata[i].Party_Code;
          // partydata.Party_Names = filtereddata[i].Party_Name;
          // setPartydata.Party_Code(filtereddata[i].Party_Code);
          // partydata[j].Party_Name(filtereddata[i].Party_Name);
          // arr[j] = filtereddata[i].Party_Code +" " + filtereddata[i].Party_Name + " " + filtereddata[i].Party_Wise_City +" " + filtereddata[i].Party_Wise_State;
          arr[j] = filtereddata[i].Party_Code;
          // partywisedata[j].partyCode = filtereddata[i].Party_Code;
          // arr[j][1] = filtereddata[i].Party_Name;
          // setPartydata.Party_Codes[0]="hi";
          // partydata.push(filtereddata[i].Party_Code);
          // let a = filtereddata[i].Party_Code;
          // let b = filtereddata[i].Party_Name;
          // partydata.map((pdata)=>(pdata[j]));         

          j++;

          }
          if(hashmap.has(filtereddata[i].Party_Code) === true)
          {
            let pvaluedata = filtereddata[i].Amount_after_Discount;            
            let datakey =filtereddata[i].Party_Code;
            let prevvalue = hashmap.get(datakey);            
            let fpvaluedata = prevvalue+pvaluedata;            
            hashmap.set(datakey,fpvaluedata)            
          }
          partySalesValue = partySalesValue+filtereddata[i].Amount_after_Discount;
        }
        // console.log(hashmap);
        // console.log(arrdata)
        // console.log(arr);
        // console.log(partywisedata[0].partyCode);
        // let arr1 = arr.flatMap((x) => x );
        // console.log(arr1);
        // let arrlength = arr.length;        
        // let datakey =filtereddata[4].Party_Code;
        // console.log(datakey);
        // console.log(hashmap.keys([0]));
        // console.log(hashmap.values([0]));
        // console.log(hashmap.get("210106220"));
        // hashmap.set(datakey,20000)
        // console.log(hashmap.get("210102447"));
        // console.log(hashmap.keys("210106220"));
        


        for(let i=0; i<hashmap.size; i++)
        {
          
          let a = arr[i];
          partywisedata[i].partyCode = a;
          // console.log(hashmap.keys([i]))
          // partywisedata[i].partyCode = hashmap.keys([i]);
          // partywisedata[i].netSale = hashmap.values([i]);
          // partywisedata[i].partyCode(current => [...current, arr[i]])
          // partywisedata.partyCode[i].push(a);
          
          // console.log(a);
        }

        for(let i=0; i<hashmap.size; i++)
        {
          let a = arr[i];
          partywisedata[i].netSale = hashmap.get(a);
        }
        // console.log(partywisedata);
        

        for(let i=0; i<hashmap.size; i++)
        {
          for(let b=0; b<filtereddata.length; b++ )
          {
            let matchdata = partywisedata[i].state;
            let matchpcode = partywisedata[i].partyCode;
            let pcode=filtereddata[b].Party_Code;
            let pname=filtereddata[b].Party_Name;
            let pcity=filtereddata[b].Party_Wise_City;
            let pstate=filtereddata[b].Party_Wise_State;
            let phqCode=filtereddata[b].HQ_Code;
            let phqName=filtereddata[b].HQ_Name;


            if(matchdata != "")
            {
              break;
            }
            else if(matchpcode != pcode)
            {
              continue;
            }
            else if(matchpcode === pcode)
            {              
              partywisedata[i].partyName = pname;
              partywisedata[i].city = pcity;
              partywisedata[i].state = pstate;
              partywisedata[i].hqCode = phqCode;
              partywisedata[i].hqName = phqName;
            }
            else
              {
                break;

              }

          }
          
        }
        partywisedata[hashmap.size].partyCode = "Grand Total";
        partywisedata[hashmap.size].netSale = partySalesValue;
        hashmap.clear();
        setPartybtnstate('');

        // for(let d=0; d<filtereddata.length; d++)
        // {
        //   let pcode=filtereddata[d].Party_Code;
        //   let pname=filtereddata[d].Party_Name;
        //   let pcity=filtereddata[d].Party_Wise_City;
        //   let pstate=filtereddata[d].Party_Wise_State;
        //   let phqCode=filtereddata[d].HQ_Code;
        //   let phqName=filtereddata[d].HQ_Name;
        //   let psalesV=filtereddata[d].Amount_after_Discount;
        //   for(let d2=0; d2<arrlength; d2++)
        //   {
        //     let pmatch = partywisedata[d2].partyCode;
        //     if(pmatch === pcode)
        //     {
        //       partywisedata[d2].partyName =;

        //     }
            
        //   }
        // }

        // for(let b=0; b<hashmap.size; b++ )
        // {
          // partydata.Party_Codes[j] = hashmap.get([b]);
          // console.log("HI");
          // console.log(hashmap.keys([j]));
          // arr=hashmap.keys([b]);
          // partywisedata.map((hashmap,i)=><option key={i}>{hashmap.partyCode}</option>)
          // setPartywisedata.partyCode = hashmap.keys([b]);
          // partydata.Party_Names = hashmap.values([b]);
          // partydataf.Party_Codesf(hashmap.keys([b]));
          // partydataf.Party_Namesf(hashmap.values([b]));
          // console.log(partydata.Party_Codes);

          // j++
        // }
        // let data = hashmap.get('210106112');
        // hashmap.clear()
        // console.log(data);
        // console.log(arr);
        // setPartydata(hashmap.keys());        
        
        // console.log(partywisedata);
        // console.log(partydataf);
        // console.log(arr);
      }
      } catch (error) {
       console.log(error)   
      }
      }



      const sappartywisereport = () => {        
        try {        
        setPartybtnstate('none');
        if(filtereddata.length <=0)
        {          
          toast.error("There is not data for Display.", { position: "top-center" });
        }
        else
        {
        let hashmap = new Map();
        
        let arr = [];
        // let arrdata = new Array[500][2];
        let j=0;
        let partySalesValue =0;
        // setPartydata("");
        for(let i=0; i<filtereddata.length; i++)
        {          
          if(hashmap.has(filtereddata[i].SHIP_TO_CODE) === false)
          {          
          hashmap.set(filtereddata[i].SHIP_TO_CODE,0)
          // arrdata[j][0] = filtereddata[i].Party_Code;
          // hashmap.set(filtereddata[i].Amount_after_Discount)
          // partydata.Party_Codes = filtereddata[i].Party_Code;
          // partydata.Party_Names = filtereddata[i].Party_Name;
          // setPartydata.Party_Code(filtereddata[i].Party_Code);
          // partydata[j].Party_Name(filtereddata[i].Party_Name);
          // arr[j] = filtereddata[i].Party_Code +" " + filtereddata[i].Party_Name + " " + filtereddata[i].Party_Wise_City +" " + filtereddata[i].Party_Wise_State;
          arr[j] = filtereddata[i].SHIP_TO_CODE;
          // partywisedata[j].partyCode = filtereddata[i].Party_Code;
          // arr[j][1] = filtereddata[i].Party_Name;
          // setPartydata.Party_Codes[0]="hi";
          // partydata.push(filtereddata[i].Party_Code);
          // let a = filtereddata[i].Party_Code;
          // let b = filtereddata[i].Party_Name;
          // partydata.map((pdata)=>(pdata[j]));         

          j++;

          }
          if(hashmap.has(filtereddata[i].SHIP_TO_CODE) === true)
          {
            let pvaluedata = filtereddata[i].TAXABLE_AMOUNT;            
            let datakey =filtereddata[i].SHIP_TO_CODE;
            let prevvalue = hashmap.get(datakey);            
            let fpvaluedata = prevvalue+pvaluedata;            
            hashmap.set(datakey,fpvaluedata)            
          }
          partySalesValue = partySalesValue+filtereddata[i].TAXABLE_AMOUNT;
        }
        // console.log(hashmap);
        // console.log(arrdata)
        // console.log(arr);
        // console.log(partywisedata[0].partyCode);
        // let arr1 = arr.flatMap((x) => x );
        // console.log(arr1);
        // let arrlength = arr.length;        
        // let datakey =filtereddata[4].Party_Code;
        // console.log(datakey);
        // console.log(hashmap.keys([0]));
        // console.log(hashmap.values([0]));
        // console.log(hashmap.get("210106220"));
        // hashmap.set(datakey,20000)
        // console.log(hashmap.get("210102447"));
        // console.log(hashmap.keys("210106220"));
        


        for(let i=0; i<hashmap.size; i++)
        {
          
          let a = arr[i];
          partywisedata[i].partyCode = a;
          // console.log(hashmap.keys([i]))
          // partywisedata[i].partyCode = hashmap.keys([i]);
          // partywisedata[i].netSale = hashmap.values([i]);
          // partywisedata[i].partyCode(current => [...current, arr[i]])
          // partywisedata.partyCode[i].push(a);
          
          // console.log(a);
        }

        for(let i=0; i<hashmap.size; i++)
        {
          let a = arr[i];
          partywisedata[i].netSale = hashmap.get(a);
        }
        // console.log(partywisedata);
        

        for(let i=0; i<hashmap.size; i++)
        {
          for(let b=0; b<filtereddata.length; b++ )
          {
            let matchdata = partywisedata[i].state;
            let matchpcode = partywisedata[i].partyCode;
            let pcode=filtereddata[b].SHIP_TO_CODE;
            let pname=filtereddata[b].CUST_NO_SP;
            let pcity=filtereddata[b].SHIPTOCITY_CUSTOMER;
            let pstate=filtereddata[b].STATE;
            let phqCode=filtereddata[b].HQ_CODE;
            let phqName=filtereddata[b].HQ_NAME;


            if(matchdata != "")
            {
              break;
            }
            else if(matchpcode != pcode)
            {
              continue;
            }
            else if(matchpcode === pcode)
            {              
              partywisedata[i].partyName = pname;
              partywisedata[i].city = pcity;
              partywisedata[i].state = pstate;
              partywisedata[i].hqCode = phqCode;
              partywisedata[i].hqName = phqName;
            }
            else
              {
                break;

              }

          }
          
        }
        partywisedata[hashmap.size].partyCode = "Grand Total";
        partywisedata[hashmap.size].netSale = partySalesValue;
        hashmap.clear();
        setPartybtnstate('');

        // for(let d=0; d<filtereddata.length; d++)
        // {
        //   let pcode=filtereddata[d].Party_Code;
        //   let pname=filtereddata[d].Party_Name;
        //   let pcity=filtereddata[d].Party_Wise_City;
        //   let pstate=filtereddata[d].Party_Wise_State;
        //   let phqCode=filtereddata[d].HQ_Code;
        //   let phqName=filtereddata[d].HQ_Name;
        //   let psalesV=filtereddata[d].Amount_after_Discount;
        //   for(let d2=0; d2<arrlength; d2++)
        //   {
        //     let pmatch = partywisedata[d2].partyCode;
        //     if(pmatch === pcode)
        //     {
        //       partywisedata[d2].partyName =;

        //     }
            
        //   }
        // }

        // for(let b=0; b<hashmap.size; b++ )
        // {
          // partydata.Party_Codes[j] = hashmap.get([b]);
          // console.log("HI");
          // console.log(hashmap.keys([j]));
          // arr=hashmap.keys([b]);
          // partywisedata.map((hashmap,i)=><option key={i}>{hashmap.partyCode}</option>)
          // setPartywisedata.partyCode = hashmap.keys([b]);
          // partydata.Party_Names = hashmap.values([b]);
          // partydataf.Party_Codesf(hashmap.keys([b]));
          // partydataf.Party_Namesf(hashmap.values([b]));
          // console.log(partydata.Party_Codes);

          // j++
        // }
        // let data = hashmap.get('210106112');
        // hashmap.clear()
        // console.log(data);
        // console.log(arr);
        // setPartydata(hashmap.keys());        
        
        // console.log(partywisedata);
        // console.log(partydataf);
        // console.log(arr);
      }
      } catch (error) {
       console.log(error)   
      }
      }


      const exportToCSV = (data, filename = 'SalesRegister.csv') => {
      const csvRows = [];

      // Get headers
      const headers = Object.keys(data[0]);
      csvRows.push(headers.join(','));

      // Loop over rows
      for (const row of data) {
        const values = headers.map(header => {
          const escaped = ('' + row[header]).replace(/"/g, '\\"');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(','));
      }

      // Create and download CSV
      const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('hidden', '');
      a.setAttribute('href', url);
      a.setAttribute('download', filename);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      };

      const handleExport = () => {
        if(filtereddata.length == 0)
        {
          toast.error("There is not Records so please again generate reports with Valid Field or Connect to QRS-Administration.", { position: "top-center" });
        }
        else{
      exportToCSV(filtereddata, 'SalesRegister.csv');
        }
      };
      const handledncnExport = () => {
        if(filtereddncndata.length == 0)
        {
          toast.error("There is not Records so please again generate reports with Valid Field or Connect to QRS-Administration.", { position: "top-center" });
        }
        else{
      exportToCSV(filtereddncndata, 'DNCNRegister.csv');
        }
      };
      

      const customStyles = {
        headRow: {
          style:{
            backgroundColor:'purple',
            color:'white',            
            height:80,                  
          },    
        },
        headCells:{
          style:{
            fontSize:'14px',
            
          }
        }
      }
      
        const columns = [
          {
              name: "Sales_Invoice_No/Sales_Return_No",
              selector: "Sales_Invoice_No/Sales_Return_No",
                            
            },
          {
            name: "Sales_Return_Type",
            selector: "Sales_Return_Type",
            // sortable:true,
            
          },
          {
            name: "Sales_Invoice_Date/Sales_Return_Date",
            selector: "Sales_Invoice_Date/Sales_Return_Date",
          },
          {
            name: "Party_Code",
            selector: "Party_Code",      
          },
          {
            name: "Party_Name",
            selector: "Party_Name",
            width: "240px",
            wrap:true,
          },
          {
            name: "Party_Wise_City",
            selector: "Party_Wise_City",
            sortable:true,
          },
          {
            name: "Party_Wise_State",
            selector: "Party_Wise_State",
          },
          {
            name: "Item_Code",
            selector: "Item_Code",
          },
          {
            name: "Alternate_S/W_Code",
            selector: "Alternate_S/W_Code",
          },
          {
            name: "Item_Name",
            selector: "Item_Name",
            width: "240px",
            wrap:true,
          },
          {
            name: "HQ_Code",
            selector: "HQ_Code",
          },
          {
            name: "HQ_Name",
            selector: "HQ_Name",
          },
          {
            name: "Item_Division",
            selector: "Item_Division",
          },
          {
            name: "Site",
            selector: "Site",
          },
          {
            name: "Bill_Qty",
            selector: "Bill_Qty",
          },
          {
            name: "Free_Qty",
            selector: "Free_Qty",
          },          
          {
            name: "Amount_after_Discount",            
            selector: "Amount_after_Discount", 
            
          },
        ];



        const sapcolumns = [
          {
              name: "Sales_Invoice_No/Sales_Return_No",
              selector: "COMMERCIAL_INV_NO",
                            
            },
          {
            name: "Sales_Return_Type",
            selector: "BILLING_DISCRIPTION",
            // sortable:true,
            
          },
          {
            name: "Sales_Invoice_Date/Sales_Return_Date",
            selector: "BILLING_DATE",
          },
          {
            name: "Party_Code",
            selector: "SOLD_TO_PARTY",      
          },
          {
            name: "Party_Name",
            selector: "CUST_NO_SP",
            width: "240px",
            wrap:true,
          },
          {
            name: "Party_Wise_City",
            selector: "SHIPTOCITY_CUSTOMER",
            sortable:true,
          },
          {
            name: "Party_Wise_State",
            selector: "STATE",
          },
          {
            name: "Item_Code",
            selector: "MATERIAL_CODE",
          },
          {
            name: "Alternate_S/W_Code",
            selector: "MATERIAL_CODE",
          },
          {
            name: "Item_Name",
            selector: "MATERIAL_DISCRIPTION",
            width: "240px",
            wrap:true,
          },
          {
            name: "HQ_Code",
            selector: "HQ_CODE",
          },
          {
            name: "HQ_Name",
            selector: "HQ_NAME",
          },
          {
            name: "Item_Division",
            selector: "DIVISION_DESCPRIPTION",
          },
          {
            name: "Site",
            selector: "PLANT",
          },
          {
            name: "Total_Qty",
            selector: "BILL_QUANTITY",
          },
          {
            name: "CUSTOMER_CATOGERY",
            selector: "CUSTOMER_CATOGERY",
          },          
          {
            name: "Amount_after_Discount",            
            selector: "TAXABLE_AMOUNT", 
            
          },
        ];

        const sapdncncolumns = [
          {
              name: "Sales_Invoice_No/Sales_Return_No",
              selector: "COMMERCIAL_INV_NO",
                            
            },
          {
            name: "Sales_Return_Type",
            selector: "BILLING_DISCRIPTION",
            // sortable:true,
            
          },
          {
            name: "Sales_Invoice_Date/Sales_Return_Date",
            selector: "BILLING_DATE",
          },
          {
            name: "Party_Code",
            selector: "SOLD_TO_PARTY",      
          },
          {
            name: "Party_Name",
            selector: "CUST_NO_SP",
            width: "240px",
            wrap:true,
          },
          {
            name: "Party_Wise_City",
            selector: "SHIPTOCITY_CUSTOMER",
            sortable:true,
          },
          {
            name: "Party_Wise_State",
            selector: "STATE",
          },
          {
            name: "Item_Code",
            selector: "MATERIAL_CODE",
          },
          {
            name: "Alternate_S/W_Code",
            selector: "MATERIAL_CODE",
          },
          {
            name: "Item_Name",
            selector: "MATERIAL_DISCRIPTION",
            width: "240px",
            wrap:true,
          },
          {
            name: "HQ_Code",
            selector: "HQ_CODE",
          },
          {
            name: "HQ_Name",
            selector: "HQ_NAME",
          },
          {
            name: "Item_Division",
            selector: "DIVISION_DESCPRIPTION",
          },
          {
            name: "Site",
            selector: "PLANT",
          },
          {
            name: "Total_Qty",
            selector: "BILL_QUANTITY",
          },
          {
            name: "CUSTOMER_CATOGERY",
            selector: "CUSTOMER_CATOGERY",
          },          
          {
            name: "Amount_after_Discount",            
            selector: "TAXABLE_AMOUNT", 
            
          },
        ];

       



    useEffect (() => {
        pagauth();
        empdataHomePage();        
        
      }, []);

  return (
    <>
    <div className="">
    <Navbar />   
    </div>
    <div className='d-flex justify-content-center align-items-top bg-white vh-100'>
    <div className='mt-3 w-100'>
    <div className='bg-white p-3 rounded w-100'>
    <div className='bg-info w-25 rounded-1 mt-1'>Division Wise Sales Report ZSM and Above:</div>
    <div className='d-flex mt-2 flex-column align-items-center'>
    <div className='mb-2'> <label style={{textAlign:"right", width:"100px"}}>From Date:-</label>    
    <input type="date" id="fromdate" onChange={(e) => handlefromDateUpdate(e)} />
    <label style={{textAlign:"right", width:"100px"}}>To Date:-</label>    
    <input style={{marginRight:"50px"}} type="date" id="todate" onChange={(e) => handletoDateUpdate(e)} />    
    </div>        
    <div>
    <button className='btn btn-primary rounded-1' style={{display:btnsitestate}} onClick={empdivemapdata}>1. Select Division Data Details</button>
    <button className='btn btn-primary rounded-1' style={{display:btnrefstate}} onClick={empsitemapdata}>2. Select Site Data Details</button>
    {/* <button className='btn btn-primary rounded-1' style={{display:btnreport}} disabled={btnreport} onClick={divwisereport}>3. Refresh Sales Report</button>     */}
    <button className='btn btn-primary rounded-1' style={{display:btnreport}} disabled={btnreport} onClick={sapdivwisereport}>3. Refresh Sales Report</button>    
    <button className='btn btn-primary rounded-1 ms-1' onClick={hqcodelist}>4. Select HQ Wise Data</button>
    <button className='btn btn-primary rounded-1 ms-2' onClick={handlehqwisedata}>5. Generate HQ/Rs. Wise Pivot</button>
    <span className='fs-6 ms-2' style={{display:hqbtnstate}}><ExportToExcelLive reportLiveDetails={values} /></span>
    <button className='btn btn-primary rounded-1 ms-1' onClick={partywiselist}>6. Select Party Data</button>
    <button className='btn btn-primary rounded-1 ms-1' onClick={sappartywisereport}>7. Generate Party Report </button>
    <button className='btn btn-primary rounded-1 ms-1' style={{display:btnreport}} disabled={btnreport} onClick={sapdivwisedncnreport}>8. Referesh Debit/Credit Note</button>
    <span className='fs-6 ms-2' style={{display:partybtnstate}}><ExportToExcelPartyLive reportPartyLiveDetails={partywisedata} /></span>
    </div>
            <div><span style={{fontSize:"12px"}}>Division:- {finaldivmapdata}</span></div>
            <div><span style={{fontSize:"13px", backgroundColor:"yellow", fontWeight:"bold"}}>Final Sales Figures in Lacs:- Proton : {Proton} || Nucleus : {Nucleus} || Molecule : {Molecule} || Adlife : {Adlife} || Blip : {Blip} || ATOM : {ATOM} || Professional : {OPR} || CPC : {CPC}  || CSD : {CSD} || Rest Value : {rest} || Total Value : {TotalValue}</span></div>
            <div><span style={{fontSize:"13px", backgroundColor:"grey", fontWeight:"bold"}}>DebitCredit Note Figures in Lacs:- Proton : {Protondncn} || Nucleus : {Nucleusdncn} || Molecule : {Moleculedncn} || Adlife : {Adlifedncn} || Blip : {Blipdncn} || ATOM : {ATOMdncn} || Professional : {OPRdncn} || CPC : {CPCdncn}  || CSD : {CSDdncn} || Rest Value : {restdncn} || Total Value : {TotalValuedncn}</span></div>
            {/* <span className='fs-6' style={{display:btnstate}}><ExportToExcelLive reportLiveDetails={tcsdbdata} /></span> */}
            
                

    {/* <div>
    <ExportToExcel reportDetails={filtereddata} />
    </div> */}
    {/* {(isLoading) ? <Loaders /> : 
  <DataTableExtensions
  columns={columns}
  data={filtereddata}
  exportHeaders={true}
  print={false}
  fileName={"SalesReport"} 
  > */}
  
    {/* <DataTable
    // title="HQ Wise For Month Sales Details:"
    // columns={columns}
    // data={filtereddata}
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"    
    // selectableRows
    // onSelectedRowsChange={handleChange}
    // selectableRowsHighlight
    
    // actions={<CSVLink data={filtereddata} filename='TMPerformanceReports' onClick={() => {}} className="btn btn-sm btn-info">Performance Data Export in Excel</CSVLink>}    
    // subHeader
    // subHeaderComponent={
    //   <input type='text' placeholder='Search here' className='w-25 form-control'
    //   value={search} onChange={(e) => setSearch(e.target.value.replace(/[^a-z^ -]/gi, ''))}
    //    />
    // }
    // subHeaderAlign='center' 
    
    
     /> 
     </DataTableExtensions>
    } */}
    {/* {
      isError && <h4 className="text-center">There are no records to display</h4>
    } */}

<span><button className='btn btn-primary rounded-1 ms-1' onClick={handleExport}>Sales Register Export to CSV</button>
<button className='btn btn-primary rounded-1 ms-1' style={{display:btndncnreport}} disabled={btndncnreport} onClick={handledncnExport}>DNCN Register Export to CSV</button></span>
<div className='bg-info w-50 rounded-1 mt-1'>SAP Live Invoice Details  :</div>
    {(isLoading) ? <Loaders /> : 
    
  <DataTableExtensions
  columns={sapcolumns}
  data={filtereddata}
  exportHeaders={true}
  print={false}
  fileName={"SalesReport"} 
  >
  
    <DataTable
    // title="HQ Wise For Month Sales Details:"
    // columns={columns}
    // data={filtereddata}
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"    
    // selectableRows
    // onSelectedRowsChange={handleChange}
    // selectableRowsHighlight
    
    // actions={<CSVLink data={filtereddata} filename='TMPerformanceReports' onClick={() => {}} className="btn btn-sm btn-info">Performance Data Export in Excel</CSVLink>}    
    // subHeader
    // subHeaderComponent={
    //   <input type='text' placeholder='Search here' className='w-25 form-control'
    //   value={search} onChange={(e) => setSearch(e.target.value.replace(/[^a-z^ -]/gi, ''))}
    //    />
    // }
    // subHeaderAlign='center' 
    
    
     /> 
     </DataTableExtensions>}
<div className='bg-info w-50 rounded-1 mt-1'>SAP Live Debit Credit Note Details  :</div>
     <DataTableExtensions
  columns={sapdncncolumns}
  data={filtereddncndata}
  exportHeaders={true}
  print={false}
  fileName={"SalesReport"} 
  >
  
    <DataTable    
    customStyles={customStyles}
    pagination
    fixedHeader
    fixedHeaderScrollHeight="450px"        
     /> 
     </DataTableExtensions>

    </div>    
            </div>
        </div>
    </div>
    </>
  )
}

export default Tcsreport